import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

export type Crumb = { label: string; href?: string };

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.label,
      item: c.href ? `https://letslistbusiness.com${c.href}` : undefined,
    })),
  };
  return (
    <>
      <nav
        aria-label="Breadcrumb"
        className="container mx-auto flex flex-wrap items-center gap-1 px-4 py-4 text-sm text-muted-foreground"
      >
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <span key={i} className="flex items-center gap-1">
              {c.href && !last ? (
                <Link to={c.href} className="hover:text-foreground">
                  {c.label}
                </Link>
              ) : (
                <span className={last ? "text-foreground font-medium" : ""}>
                  {c.label}
                </span>
              )}
              {!last && <ChevronRight className="h-3.5 w-3.5 opacity-60" />}
            </span>
          );
        })}
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
      />
    </>
  );
}
